import {gql, useLazyQuery} from '@apollo/client';
import {useSnackbar} from 'notistack';
import {FullCuroSync, FullCuroSyncVariables} from '../../schema-types/FullCuroSync';

export const useCuroSync = () => {
  const {enqueueSnackbar} = useSnackbar();
  const [_onFullCuro, {data, loading}] = useLazyQuery<
    FullCuroSync,
    FullCuroSyncVariables
  >(gql`
    query FullCuroSync($onlyLogs: Boolean!) {
      fullSync(curoEmail: "oneview-admin@saltus.co.uk", onlyLogs: $onlyLogs) {
        id
        isDeleted
        isDummy
        lastSyncStart
        lastSyncEnd
      }
    }
  `);
  const getSyncData = () => {
    _onFullCuro({
      variables: {
        onlyLogs: true,
      },
    });
  };
  const startFullSync = () => {
    _onFullCuro({
      variables: {
        onlyLogs: false,
      },
    })
      .then((res) => {
        enqueueSnackbar({
          message: 'Full sync is processing, please wait up to 5 minutes',
          variant: 'success',
        });
      })
      .catch(() => {
        enqueueSnackbar({message: 'Unable to start full curo sync', variant: 'error'});
      });
  };
  return {
    syncData: data?.fullSync,
    getSyncData,
    startFullSync,
    fullSyncLoading: loading,
  };
};
